module.exports = __webpack_public_path__ + "static/img/pattern02.58463122.png";